import React from 'react';
import {Link} from 'react-router-dom';
import {Card} from 'semantic-ui-react';

const BlogCard = ({data}) => {
    return (
        <div className="blog_card">
        <Card>
            <img src={data.fields.profile.fields.file.url} className="blog_card_img" alt="loading" />
            <Card.Content>
                 <Card.Header>
                    <Link to={`/blogs/${data.sys.id}`} className="blog_card_link">{data.fields.heading}</Link> 
                </Card.Header>
                 <Card.Description>
                     By {data.fields.author}
                 </Card.Description>
            </Card.Content>
        </Card>
        </div>
    )
};


export default BlogCard;